import React from 'react';
import styled from 'styled-components';
import { LockKeyhole } from 'lucide-react';

const Button = styled.button<{ $primary?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.35rem;
  padding: 0.55rem 0.8rem;
  border: 1px solid ${p => p.$primary ? 'rgba(56, 189, 248, 0.55)' : 'rgba(148, 163, 184, 0.28)'};
  border-radius: 9px;
  background: ${p => p.$primary ? 'rgba(14, 116, 144, 0.34)' : 'rgba(15, 23, 42, 0.64)'};
  color: #f8fafc;
  cursor: pointer;
  font-size: 0.72rem;
  font-weight: 800;

  &:hover:not(:disabled) { border-color: #38bdf8; }
  &:disabled { cursor: not-allowed; opacity: 0.52; }
`;

const Explanation = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin-top: 0.45rem;
  color: #fbbf24;
  font-size: 0.68rem;
  line-height: 1.4;
`;

export const PrerequisiteAction: React.FC<{
  children: React.ReactNode;
  disabled?: boolean;
  disabledReason?: string;
  primary?: boolean;
  onClick?: () => void;
}> = ({ children, disabled = false, disabledReason, primary = false, onClick }) => (
  <div>
    <Button
      type="button"
      $primary={primary}
      disabled={disabled}
      aria-disabled={disabled}
      aria-describedby={disabled && disabledReason ? 'abf-action-prerequisite' : undefined}
      title={disabled ? disabledReason : undefined}
      onClick={onClick}
    >
      {disabled && <LockKeyhole size={14} aria-hidden="true" />}
      {children}
    </Button>
    {disabled && disabledReason && (
      <Explanation id="abf-action-prerequisite">
        <LockKeyhole size={13} aria-hidden="true" />
        <span>{disabledReason}</span>
      </Explanation>
    )}
  </div>
);
